import Layout from '@layouts/Layout';
import ScientificCollaborationProgram from '@screens/ScientificCollaborationProgram';

import React, { memo } from 'react';

const title = 'Traqq Scientific Collaboration Program';
const description = 'The Traqq scientific collaboration program aims to unite academic needs with its powerful time management tools to contribute to science.';

const ScientificCollaborationPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <ScientificCollaborationProgram />
    </Layout>
);

export default memo(ScientificCollaborationPage);